/* @flow strict */

import moment from 'moment';
import { currency } from '/client/src/constants/';

export const columns = [
  {
    selector: 'payout_event_created_time_utc',
    name: 'Date(UTC)',
    sortable: true,
    cell: (row: {}) => {
      try {
        const date = moment(row.payout_event_created_time_utc).format(
          'MM/DD/YYYY'
        );

        return date;
      } catch (e) {
        console.log(e);

        return '';
      }
    }
  },
  {
    selector: 'currency',
    name: 'Currency',
    sortable: true
  },
  {
    selector: 'amount',
    name: 'Another Transfered',
    sortable: true,
    cell: (row: {}) => {
      return `${currency[row.currency]}${row.amount / 100}`;
    }
  },
  {
    selector: 'arrived_time_utc',
    name: 'Arived Time(UTC)',
    sortable: true,
    cell: (row: {}) => {
      try {
        const date = moment(row.arrived_time_utc).format('MM/DD/YYYY');

        return date;
      } catch (e) {
        console.log(e);
        return '';
      }
    }
  },
  {
    selector: 'source_type',
    name: 'Source Type',
    sortable: true
  },
  {
    selector: 'status',
    name: 'Status',
    sortable: true
  },
  {
    selector: 'type',
    name: 'Type',
    sortable: true
  }
];

